"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelApple = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelApple = function SvgChannelApple(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_apple__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61 25c-10.609 0-20.783 3.474-28.284 9.656C25.214 40.84 21 49.225 21 57.968c.01 5.688 1.804 11.276 5.21 16.223 3.404 4.946 8.304 9.083 14.222 12.007-1.576 3.492-3.94 6.767-6.994 9.688 5.923-1.029 11.482-3.19 16.246-6.315A47.97 47.97 0 0061 90.936c10.609 0 20.783-3.473 28.284-9.656C96.786 75.097 101 66.712 101 57.968c0-8.744-4.214-17.129-11.716-23.312C81.783 28.474 71.61 25 61 25z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_apple__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#5BF675"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#0CBD2A"
  }))));
};

exports.SvgChannelApple = SvgChannelApple;